import script from "./BottomView.vue?vue&type=script&setup=true&lang=ts"
export * from "./BottomView.vue?vue&type=script&setup=true&lang=ts"

import "./BottomView.vue?vue&type=style&index=0&id=02025516&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02025516"]])

export default __exports__